import React from 'react';
import { ErrorPage } from '../../components/common/page/ErrorPage';
import { useDocumentTitle } from '../../hooks/useDocumentTitle';

export const PageExpiredPage = () => {
    useDocumentTitle('Page Expired');
    return (
        <ErrorPage
            code="419"
            title="Page Expired"
            description="Sorry, your session has expired.<br/> Please refresh the page.">
            <div className="page-expired-icon text-center">
                <span className="fa-stack fa-5x mb-3">
                    <i className="fas fa-file fa-stack-2x text-primary"></i>
                    <i
                        className="far fa-clock fa-stack-1x text-white"
                        data-fa-transform="shrink-1 down-3"></i>
                </span>
            </div>
        </ErrorPage>
    );
};
